import axiosInstance from './axiosInstance';

// GET all measurementUnitses
export const getMeasurementUnits = async () => {
  try {
    const response = await axiosInstance.get('/measurement-units');
    return response.data;
  } catch (error) {
    console.error("Error fetching measurement-units:", error.response?.data || error);
    throw error;
  }
};

// GET a single measurementUnits
export const getMeasurementUnitsById = async (id) => {
  try {
    const response = await axiosInstance.get(`/measurement-units/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching measurement-units:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new measurementUnits
export const createMeasurementUnits = async (measurementUnitsData) => {
  try {
    const response = await axiosInstance.post('/measurement-units', measurementUnitsData);
    return response.data;
  } catch (error) {
    console.error("Error creating measurement-units:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing measurementUnits
export const updateMeasurementUnits = async (id, measurementUnitsData) => {
  try {
    const response = await axiosInstance.put(`/measurement-units/${id}`, measurementUnitsData);
    return response.data;
  } catch (error) {
    console.error("Error updating measurement-units:", error.response?.data || error);
    throw error;
  }
};

// DELETE a measurementUnits
export const deleteMeasurementUnits = async (id) => {
  try {
    const response = await axiosInstance.delete(`/measurement-units/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting measurement-units:", error.response?.data || error);
    throw error;
  }
};
